import { Controller } from "@hotwired/stimulus"

// Décompte avant l'ouverture de la saisie (page d'annonce du match).
// Recharge la page quand le seuil d'ouverture est atteint : le serveur
// bascule alors sur l'interface de saisie.
export default class extends Controller {
  static targets = ["display"]
  static values = {
    startsAt: String,
    openBeforeSeconds: { type: Number, default: 900 }
  }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const opensAt = Date.parse(this.startsAtValue) - this.openBeforeSecondsValue * 1000
    const remaining = Math.floor((opensAt - Date.now()) / 1000)

    if (remaining <= 0) {
      clearInterval(this.timer)
      window.location.reload()
      return
    }

    const h = Math.floor(remaining / 3600)
    const m = Math.floor((remaining % 3600) / 60)
    const s = remaining % 60
    const pad = (n) => String(n).padStart(2, "0")
    this.displayTarget.textContent = h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`
  }
}
